import { Card } from "react-bootstrap";
import { FaArrowAltCircleRight, FaUser, FaBuilding, FaFileAlt, FaCalendarDay } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

interface Props {
  title: string;
  count?: number;
  icon?: JSX.Element; // Updated to accept a JSX.Element
  colorIndex: number;
}

const colorClasses = [
  "dark-blue",
  "dark-green",
  "medium-orange",
  "magenta",
  "dark-brown",
  "lime-green",
  "light-green",
];

// Define icons
const iconMap: Record<string, JSX.Element> = {
  "Forms": <FaFileAlt />,
  "Organizations": <FaBuilding />,
  "User Registrations": <FaUser />,
  "Forms Conducted Last Month": <FaCalendarDay />,
  "Forms Conducted Current Month": <FaCalendarDay />,
  "Forms To Be Conducted Next Month": <FaCalendarDay />,
};

export default function ESStatisticsCard(props: Props) {
  const { title, count, icon, colorIndex } = props;
  const navigate = useNavigate();

  const handleMoreInfoNavigation = (name: string) => {
    switch (name) {
      case "Forms":
        navigate("/form-assignment");
        break;
      case "Organizations":
        navigate("/organizations");
        break;
      case "User Registrations":
        navigate("/users");
        break;
      case "Forms Conducted Last Month":
        navigate("/form-assignment");
        break;
      case "Forms Conducted Current Month":
        navigate("/form-assignment");
        break;
      case "Forms To Be Conducted Next Month":
        navigate("/form-assignment");
        break;
      default:
        break;
    }
  };

  // Get the icon based on title or fallback to default icon
  const renderIcon = iconMap[title];

  return (
    <div>
      <Card className={`${colorClasses[colorIndex]} px-0`}>
        <div className="card-content">
          <div className="mt-2">
            <span className="total-count">{count}</span>
            <span className="stats-icon" >{renderIcon}</span>
          </div>
          <p className="stats-label">{title}</p>
          <div
            className="more-info-label"
            id={title}
            onClick={() => {
              handleMoreInfoNavigation(title);
            }}
            onKeyDown={(event: React.KeyboardEvent) => {
              if (event.key === "Enter" || event.key === " ") {
                handleMoreInfoNavigation(title);
              }
            }}
            tabIndex={0}
            role="button"
          >
            More Info. <FaArrowAltCircleRight />
          </div>
        </div>
      </Card>
    </div>
  );
}
